import React, { useState, useRef } from 'react';
import './FileUpload.css'
import Swal from 'sweetalert2';

import Util from './ait/Util.js';
const FileUpload = ({onUploaded, uploadType, onLogout}) => {
  const [file, setFile] = useState(null); // Store selected file
  const [failMsg, setFailMsg] = useState("File upload failed. Please try again.")
  const [isUploading, setIsUploading] = useState(false); // Track upload status
  const [uploadSuccess, setUploadSuccess] = useState(null); // Track upload success/failure
  const [showUploadForm, setShowUploadForm] = useState(true); // Control form visibility after upload
  const [prefix, setPrefix] = useState(""); // Control form visibility after upload
  const [fixName, setFixName] = useState(false);
  const [updatedName, setUpdatedName] = useState("");

  const fileInputRef = useRef(null);


  const fetchWithAuth = async (url, options = {}) => {
    const response = await fetch(url, {
      ...options,
      credentials: "include", // Send cookies/session
    });
  
    if (response.status === 401 || response.status === 403) {
      console.warn("JWT invalid or expired. Logging out...");
      onLogout(); // <-- your logout function
      throw new Error("Unauthorized");
    }
  
    return response;
  };
  

  // Handle file selection
  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
    }
  };

  // Handle file selection
  const handlePrefixChange = (event) => {
    const prefix = event.target.value;
    setPrefix(prefix);    
  };

    // Handle file selection
  const handleNameChange = (event) => {
      const newName = event.target.value;
      setUpdatedName(newName);    
    };
  
  
  // Handle form submission
  const uploadFunc = async (e) => {
    e.preventDefault();

    if (!file) {
      console.log('Please select an image to upload.');
      return;
    }

    let tPrefix = prefix.trim()
    // Create a FormData object to send the file
    const formData = new FormData();
    formData.append('image', file);
    formData.append('prefix',  tPrefix);   // Append the prefix

    const command = Util.serverName + "/protected/upload"; // Base API endpoint

    try {
      const response = await fetchWithAuth(command, {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        const data = await response.json();
        // setMessage(`File uploaded successfully: <a href="/uploads/${data.file.filename}" target="_blank">View Image</a>`);
        console.log(`File uploaded successfully: <a href="/uploads/${data.file.filename}" target="_blank">View Image</a>`);
        if(data.status === true)
        {
          if (fileInputRef.current) {
            fileInputRef.current.value = '';
          }
          setFile(null);
          setUploadSuccess(true);
          onUploaded(true, data);
        }
        else
        {
          setFile(null);
          setUploadSuccess(false);
          setFailMsg("Disk Quota Full");
          onUploaded(false);          
        }
          

      } else {
        
        console.log('Error uploading file.');
        setUploadSuccess(false);
        setFailMsg("File upload failed. Please try again.");        
        onUploaded(false);
      }
    } catch (error) {      
      console.log('Error uploading file: ' + error.message);
      setUploadSuccess(false);
      setFailMsg("File upload failed. Please try again.");
      onUploaded(false);
    }
  };

  // Handle HTML file form submission
const uploadFuncT = async (e) => {
  e.preventDefault();

  if (!file) {
    console.log('Please select an HTML file to upload.');
    return;
  }

  let tPrefix = prefix.trim();

  // Create a FormData object to send the file


  const formData = new FormData();
  if(fixName==true)
  {
    const renamedFile = new File([file], updatedName, {
      type: file.type || "text/plain", // important fallback for .ait      
      lastModified: file.lastModified
    });
   
    formData.append('htmlFile', renamedFile);  // <-- changed from 'image' to 'htmlFile'
    formData.append('prefix', tPrefix); // Optional metadata, if needed by the server
  }
  else
  {
    formData.append('htmlFile', file);
    formData.append('prefix',  tPrefix);   // Append the prefix
  }

  const command = Util.serverName + "/protected/uploadT"; // <-- changed endpoint

  try {
    const response = await fetchWithAuth(command, {
      method: 'POST',
      body: formData,
    });

    if (response.ok) {
      const data = await response.json();
      

      if(data.status === true)
      {

        if (fileInputRef.current) 
        {
          fileInputRef.current.value = '';
        }
        setFile(null);
        setUploadSuccess(true);
        onUploaded(true, data);
      }
      else
      {
        setFile(null);
        setUploadSuccess(false);
        setFailMsg("Disk Quota Full");
        onUploaded(false);


      }
    } else {
      console.log('Error uploading HTML file.'); 
      console.log(JSON.stringify(response));
      setUploadSuccess(false);
      setFailMsg("File upload failed. Please try again.");        
      onUploaded(false);
    }
  } catch (error) {
    console.log('Error uploading file: ' + error.message);
    setUploadSuccess(false);
    setFailMsg("File upload failed. Please try again.");        
    onUploaded(false);
  }
};


  // Handle file upload (simulate an API call)
  const handleUploadI = async (e) => {
    if (!file) {
      // alert("Please select a file first!");
      Swal.fire({
        title: 'Info',
        text: "Please select a file first!",
        icon: 'info',
        confirmButtonText: 'OK',
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,    
      });    

      setIsUploading(false);

      return;
    }

    setIsUploading(true);
    setUploadSuccess(null); // Reset success/failure state

    let u = Util.getInstance();
    let r = await u.checkPrefix(prefix);

    if(r==false)
    {
      Swal.fire({
        title: 'Info',
        text: "Invalid prefix",
        icon: 'info',
        confirmButtonText: 'OK',
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,    
      });   
      setIsUploading(false);
      setUploadSuccess(false);

      return; 
    }

    await uploadFunc(e)
    setIsUploading(false);
    

  };


    // Handle file upload (simulate an API call)
    const handleUploadT = async (e) => {
      if (!file) {
        // alert("Please select a file first!");
        Swal.fire({
          title: 'Info',
          text: "Please select a file first!",
          icon: 'info',
          confirmButtonText: 'OK',
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,    
        });    
  
        setIsUploading(false);
  
        return;
      }

      console.log("name: ",file.name);
      if(file.name.match(/^([a-zA-Z0-9_-]+)(\.(html|ait|svg))$/)==null && fixName==false)
      {
             // alert("Please select a file first!");
             Swal.fire({
              title: 'Info',
              text: "The file name is formated incorrectly. Please enter another name without spaces or invalid characters. Please add html or ait at end",
              icon: 'info',
              confirmButtonText: 'OK',
              allowOutsideClick: false,
              allowEscapeKey: false,
              allowEnterKey: false,    
            });    
      
            setFixName(true);            
            return;
      }

      if(fixName==true)
      {
          console.log("updated name: ",updatedName);
          if(updatedName.match(/^([a-zA-Z0-9_-]+)(\.(html|ait|svg))$/)==null)
          {
              // alert("Please select a file first!");
              Swal.fire({
                  title: 'Info',
                  text: "Invalid Update File Name",
                  icon: 'info',
                  confirmButtonText: 'OK',
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                  allowEnterKey: false,    
              });    
            
              setUpdatedName("");
              return;
          }
          else
          {
            setFixName(false);
          }
        }
  
      setIsUploading(true);
      setUploadSuccess(null); // Reset success/failure state
  
      let u = Util.getInstance();
      let r = await u.checkPrefix(prefix);
  
      if(r==false)
      {
        Swal.fire({
          title: 'Info',
          text: "Invalid prefix",
          icon: 'info',
          confirmButtonText: 'OK',
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,    
        });   
        setIsUploading(false);
        setUploadSuccess(false);
  
        return; 
      }
  
      await uploadFuncT(e);
      setUpdatedName("");
      setFixName(false);
      setIsUploading(false);
        
    };
  
  const handleUpload=async (e) =>{
    if(uploadType=="template")
    {
      await handleUploadT(e);
    }
    else
    {
      await handleUploadI(e);
    }
  }

  // Handle OK button click
  const handleOkClick = () => {
    setShowUploadForm(true); // Show the form again to allow another upload
    setFile(null); // Reset the file input
    setUploadSuccess(null); // Reset the upload success state
  };

  let h2String="Upload Image"
  let acceptString = "image/*";
  let helpString="Example: IMG -use this prefix to group your files for AI recognition";

  if(uploadType=="template")
  {
    h2String = "Upload Html or AIT Files or SVG Files";
    acceptString = ".html,text/html,.ait,.svg,image/svg+xml";
    helpString = "New name should not have any spaces - or _ allowed. Must end in .html";
  }


  const renderPrefix = () =>
  {
    if(uploadType=="dashboard")
    {
      return (
          <div>          
          <input
            id="prefix"
            type="text"
            placeholder="Enter prefix here"
            onChange={handlePrefixChange}
          />
          <div class="help-text">{helpString}</div>
        </div>)
    }
    else
    {
      if(fixName==true)
      {
        return (
          <div>          
          <input
            id="prefix"
            type="text"
            placeholder="Enter new name here"
            onChange={handleNameChange}
          />
          <div class="help-text">{helpString}</div>
        </div>)
      }      
    }
  }

  return (
    <div className="upload-container">
      {/* Upload Form: Only visible before the upload */}
      {showUploadForm&& (
        <>
          <h2>{h2String}</h2>
          {/* File Input */}
          <div>
            <input
              type="file"
              accept={acceptString}
              onChange={handleFileChange}
              ref={fileInputRef}
            />
          </div>
          {/* Upload Button */}
          <div className="upload-buttons">
            <button
              className="upload-btn"
              onClick={handleUpload}
              disabled={isUploading || !file}
            >
               {isUploading ? (
                      <>
                        <div className="upload-button-spinner"></div>
                        Uploading...
                      </>
                    ) : (
                      'Upload'
                )}
            </button>
          </div>


          {/* Success or failure message */}
          {uploadSuccess !== null && (
            <div className="upload-status">
              {uploadSuccess ? (
                <p style={{ color: 'green' }}>File uploaded successfully!</p>
              ) : (
                <p style={{ color: 'red' }}>{failMsg}</p>
              )}
            </div>
          )}

          {renderPrefix()}
        </>
      )}

      {/* Modal - Show only when uploading or after upload complete */}
      {/*
      {uploadSuccess !== null && (
        <div className="upload-modal">
          <div className="modal-content">            
            <button className="ok-btn" onClick={handleOkClick}>
              OK
            </button>
          </div>
        </div>
      )}
      */}
    </div>
  );
};

export default FileUpload;

